import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
import About from '../components/About/About';
import Services from "../components/Services/Services";
import WhyChooseUs from "../components/WhyChooseUse/WhyChooseUs";
import Portfolio from "../components/Portfolio/Portfolio";
import Testimonials from "../components/Testimonials/Testimonials";
import QuoteSection from "../components/QuoteSection/QuoteSection";
import AboutIntro from "../components/AboutIntro/AboutIntro";
import ProductSection from "../components/ProductSection/ProductSection";
import Footer from "../components/Footer/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <About/>
      <AboutIntro/>
      <Services/>
      <WhyChooseUs/>
      <ProductSection/>
      <QuoteSection/>
      <Footer/>

    </>
  );
}